import { request } from '../fetch';
export { sendReforcoOperation as sendSangriaOperation } from './reforcoOperation';

let checking = false;
export async function checkPendingSangrias(onUpdated) {
  if (checking) return;
  checking = true;
  try {
    const keys = Object.keys(localStorage).filter((key) => key.startsWith('osteomed:sangria-pendente:'));
    for (const key of keys) {
      try {
        const pending = JSON.parse(localStorage.getItem(key));
        const { caixaId, chave, clinica } = pending.body;
        const result = await request(`api/financas/sangria/operacao/${caixaId}/${chave}`);
        if (result.concluida) {
          localStorage.removeItem(key);
          onUpdated(clinica);
        }
      } catch { /* Keep the original request until the server confirms completion. */ }
    }
  } finally { checking = false; }
}
